// Same 14h–18h window as the legacy widget's PickupCalendar: carriers read
// pickupTimeStart/End, never `instruction` (free collection text).
const PICKUP_HOUR_START = 14;
const PICKUP_HOUR_END = 18;

const WEEKDAYS = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"] as const;

export type PickupRule = {
  noticePeriod?: { min?: number; max?: number };
  availableDays?: Partial<Record<(typeof WEEKDAYS)[number], boolean>>;
};

export function localDateFromString(value: string): Date {
  const [y, m, d] = value.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function localDateToString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function pickupWindowFromDate(pickupDate: string) {
  const start = localDateFromString(pickupDate);
  const end = localDateFromString(pickupDate);
  start.setHours(PICKUP_HOUR_START);
  end.setHours(PICKUP_HOUR_END);
  return { pickupTimeStart: start.getTime(), pickupTimeEnd: end.getTime() };
}

function addDays(date: Date, days: number): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
}

function isWeekdayAllowed(rule: PickupRule | null | undefined, date: Date): boolean {
  if (!rule?.availableDays) return true;
  return rule.availableDays[WEEKDAYS[date.getDay()]] === true;
}

export function isPickupDayDisabled(rule: PickupRule | null | undefined, date: Date, today = new Date()): boolean {
  const day = addDays(date, 0);
  const min = addDays(today, rule?.noticePeriod?.min ?? 1);
  const max = rule?.noticePeriod?.max;
  if (day < min) return true;
  if (max && day > addDays(today, max)) return true;
  return !isWeekdayAllowed(rule, day);
}

export function firstPickupDate(rule: PickupRule | null | undefined, today = new Date()): string | undefined {
  // Bounded scan: a rule allowing no weekday must not loop forever.
  for (let offset = 0; offset < 31; offset++) {
    const candidate = addDays(today, offset);
    if (!isPickupDayDisabled(rule, candidate, today)) return localDateToString(candidate);
  }
  return undefined;
}
